import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'memberPage', en);
i18next.addResourceBundle('jp', 'memberPage', jp);

const MemberConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/members',
			exact: true,
			component: React.lazy(() => import('./Member'))
		}
	]
};

export default MemberConfig;
